import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage.service';
import { OriginalDocumentPdfService } from 'src/app/services/original-document-pdf.service';
import { wrapMixedLocaleBidi } from 'src/app/utils/mixed-locale-bidi';


@Component({
    selector: 'app-success-dialog',
    templateUrl: './success-dialog.component.html',
    styleUrls: ['./success-dialog.component.scss'],
    standalone: false
})
export class SuccessDialogComponent implements OnInit {
  message: string = '';
  isSuccess: boolean = false;
  /** Warning popup (e.g. upload `warning_message`) — red styling, triangle icon, not an error X. */
  isWarning: boolean = false;
  /** iOS Save prompt — use success/check look, not error/red. */
  isSavePrompt = false;
  /** When true, show Cancel + Confirm instead of a single Close/Continue button. */
  hasActions = false;
  confirmLabel = 'Save';
  cancelLabel = 'Cancel';
  isSubmitting = false;
  labels: any;
constructor(private storageService: StorageService, private _mdr: MatDialogRef<SuccessDialogComponent>,
    private originalDocumentPdf: OriginalDocumentPdfService,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.storageService.getLabels().subscribe((labelsRes: any) => {
        if (labelsRes) {
          this.labels = { ...labelsRes };
        }
      })
    }

  ngOnInit(): void {
    this.isSuccess = !!this.data?.isSuccess;
    this.isWarning = !!this.data?.isWarning;
    this.isSavePrompt = !!this.data?.isSavePrompt;
    this.hasActions = !!this.data?.actions;
    if (this.data?.actions?.confirmLabel) {
      this.confirmLabel = this.data.actions.confirmLabel;
    }
    if (this.data?.actions?.cancelLabel) {
      this.cancelLabel = this.data.actions.cancelLabel;
    }
    this.message = this.formatDialogMessage(this.data?.message);

    if (this.isSuccess && String(this.data?.message ?? '').toLowerCase() === 'success') {
      this._mdr.addPanelClass('qwd-success-check-dialog');
      setTimeout(() => {
        this.onClose();
      }, 2500);
    }
  }

  /** API errors arrive as arrays; mixed Arabic/Latin needs bidi isolates like static labels. */
  private formatDialogMessage(raw: unknown): string {
    const text = Array.isArray(raw)
      ? String(raw[0] ?? '').trim()
      : String(raw ?? '').trim();
    return wrapMixedLocaleBidi(text);
  }

  onClose() {
  this._mdr.close(this.hasActions ? 'cancelled' : false);
  document.body.style.overflow = 'auto'; 
    document.body.classList.remove('cdk-global-scrollblock');

}

  async onConfirm() {
    const savePayload = this.data?.savePayload as { base64?: string; fileName?: string } | undefined;
    if (!savePayload?.base64) {
      this._mdr.close(true);
      this.unlockBodyScroll();
      return;
    }
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    try {
      const shared = await this.originalDocumentPdf.downloadPdfFromBase64(
        savePayload.base64,
        savePayload.fileName || 'document.pdf'
      );
      this._mdr.close(shared ? 'shared' : 'failed');
    } finally {
      this.isSubmitting = false;
      this.unlockBodyScroll();
    }
  }

  private unlockBodyScroll(): void {
    document.body.style.overflow = 'auto';
    document.body.classList.remove('cdk-global-scrollblock');
  }

}
